import React from "react";
import { mapMarkerSelectionFilter } from "../../utils/map-selection-glow";

interface PointMarkerProps {
  type: string;
  onClick: () => void;
  onMouseOver: () => void;
  onMouseOut: () => void;
  title: string;
  isCategoryOrTagSelected: boolean;
  isActive: boolean;
}

const PointMarker: React.FC<PointMarkerProps> = ({
  type,
  onClick,
  onMouseOver,
  onMouseOut,
  title,
  isCategoryOrTagSelected,
  isActive,
}) => {
  const iconSrc = `../../../images/icons/${type.toLowerCase()}.svg`;
  const size = isActive || isCategoryOrTagSelected ? 24 : 16;

  return (
    <img
      src={iconSrc}
      alt={title}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        position: "absolute",
        top: `-0px`,
        left: `-0px`,
        cursor: "pointer",
        pointerEvents: "auto",
        filter: mapMarkerSelectionFilter(isActive),
        borderRadius: isActive ? "50%" : "0",
        zIndex: "4",
      }}
    />
  );
};

export default React.memo(PointMarker);
